.reports {
  display: flex;
  flex-direction: column;
  margin: 3rem 2.5rem;
  padding: 2rem 3rem;
  border-radius: 1rem;
  background-color: var(--deposit-withdraw-bg-color);
}

.headerText {
  display: flex;
}

.downloadList {
  display: grid;
  grid-template-columns: auto auto;
  gap: 2rem;
  margin: 3rem 2rem;
}

@media only screen and (max-width: 550px) {
  .downloadList {
    grid-template-columns: auto;
  }
}

.report {
  display: flex;
  padding: 1.5rem;
  justify-content: space-between;
  composes: border from '../../overview/Overview.css';
}

.reportBig {
  composes: report;
  grid-column: span 2;
}

.searchInvoices {
  width: 45%;
}

.invoicesList {
  display: flex;
  margin-top: 1.5rem;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.reportBody {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
}

.dateInput {
  width: 50%;
}

.downloadText {
  display: flex;
  flex-direction: column;
}

.info {
  display: flex;
}

@media (max-width: 568px) {
  .reports {
    margin: 1rem;
    padding: 1rem 0.7rem;
  }
}
